<template>
  <v-app>
    <v-navigation-drawer
      v-model="nav_drawer"
      :permanent="!isMobile"
      :temporary="isMobile"
      app
      width="300"
    >
      <Drawer :appTitle="appTitle" />
    </v-navigation-drawer>
    <v-app-bar
      v-if="isMobile"
      color="primary"
      dark
      app
    >
      <v-app-bar-nav-icon @click.stop="nav_drawer = !nav_drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ appTitle }}</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-progress-linear v-if="loading" fixed color="primary" indeterminate />
      <v-container fluid class="router-view-container">
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Drawer from "@/components/Drawer2";
import {isMobileMixin} from "@/mixins";
import {mapActions, mapState} from "vuex";

export default {
  name: "Home",
  mixins: [isMobileMixin],
  components: {Drawer},
  data() {
    return {
      nav_drawer: false,
      appTitle: 'iAnnotate Customer Dashboard',
    }
  },
  computed: {
    ...mapState(['loading', 'profile'])
  },
  methods: {
    ...mapActions(['getProfile']),
  },
  async mounted() {
    if (!this.profile) await this.getProfile()
  },
}
</script>

<style scoped>
.router-view-container {
  margin: 0 !important;
  padding: 0 !important;
}
</style>